import { isMatching, P } from "ts-pattern";

export function isQueryNotFoundError(error: unknown) {
  return isQueryError(error) && error.status == 404;
}

const isQueryError = isMatching({ status: P.number });

export function isSignedOfferRequiredError(error: unknown) {
  return isMatching({ message: "E_SIGNED_OFFER_REQUIRED" }, error);
}
